import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row justify-center" }
const _hoisted_2 = { class: "col col-md-10 col-xl-8 q-py-lg" }

import { onMounted } from 'vue'
import router from './router'
import { useAuthStore } from "@/modules/authentication/AuthService"

import { container } from './system/container'
import { TOKENS } from './system/tokens'

import HeaderToolbar from '@/components/HeaderToolbar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authService = container.get(TOKENS.authService)
const auth = useAuthStore()

onMounted(async () => {
  const loginHandled = await authService.loginEnd(window.location.href)
  console.log('Is Authenticated', auth.isAuthenticated)
  console.log('loginHandled', loginHandled)
  if (loginHandled) {
    // navigate to root view
    router.replace({path: "/"})
  }
})

auth.$subscribe((mutation, state) => {
  console.log("SUB AUTH")
  if (!auth.isAuthenticated) {
    router.replace({path: "/start"})
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hhh lpR fFf" }, {
    default: _withCtx(() => [
      _createVNode(HeaderToolbar),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_view)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})